import { RowBaseGutter, RowMedia, RowProps } from "./interface";
import styles from "./index.module.scss";
import { useMemo } from "react";
import { rem } from "@/utils/adaptor";
import classNames from "classnames";

const DefaultGutter = 0;

const Row = (props: RowProps) => {
  const {
    gutter = DefaultGutter,
    children,
    className,
    style,
    ...restProps
  } = props;

  const gutterVars = useMemo(() => {
    const vars: Record<string, any> = {};

    const handleGutter = (g: RowBaseGutter, key = "") => {
      const rowGutterKey = `--${["row", "gutter", key]
        .filter(Boolean)
        .join("-")}`;
      const columnGutterKey = `--${["column", "gutter", key]
        .filter(Boolean)
        .join("-")}`;
      if (typeof g === "number") {
        vars[rowGutterKey] = `${rem(g)}rem`;
        vars[columnGutterKey] = `${rem(g)}rem`;
      } else if (Array.isArray(g)) {
        vars[rowGutterKey] = `${rem(g[0] ?? DefaultGutter)}rem`;
        vars[columnGutterKey] = `${rem(g[1] ?? DefaultGutter)}rem`;
      }
    };

    if (typeof gutter === "number" || Array.isArray(gutter)) {
      handleGutter(gutter);
    } else if (typeof gutter === "object") {
      Object.entries(gutter).forEach(([_key, value]) => {
        // xxs 就等于是默认的移动分辨率，不需要设置key
        const key = _key === RowMedia.xxs ? "" : _key;
        handleGutter(value, key);
      });
    }

    return vars;
  }, [gutter]);

  return (
    <div
      className={classNames(styles.container, className)}
      style={{
        ...style,
        ...gutterVars,
      }}
      {...restProps}
    >
      {children}
    </div>
  );
};

Row.displayName = "Row";

export default Row;
